const letterOnly = (string) => {
  return string.replace(/[^a-zA-Z ]/g, '')
}

export default letterOnly
